"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.offAuthListener = exports.disposeAuthData = exports.onAuthAppBack = exports.openAuthMiniApp = void 0;
// import 'dingtalk-jsapi/entry/mobile';
require("dingtalk-jsapi/entry/union");
var env_1 = require("dingtalk-jsapi/lib/env");
var sdkLib_1 = require("dingtalk-jsapi/lib/sdk/sdkLib");
var openLink_1 = __importDefault(require("dingtalk-jsapi/api/biz/util/openLink"));
var callComponent_1 = __importDefault(require("dingtalk-jsapi/api/biz/util/callComponent"));
var navigateToMiniProgram_1 = __importDefault(require("dingtalk-jsapi/api/biz/navigation/navigateToMiniProgram"));
var eventemitter2_1 = require("eventemitter2");
var isFloatMiniAppOpen = false;
var AUTH_MINI_APPID = '5000000000174977';
var AUTH_BACK_DATA = 'AUTH_BACK_DATA';
var _a = env_1.getENV(), platform = _a.platform, version = _a.version, appType = _a.appType;
var emitter = new eventemitter2_1.EventEmitter2();
function isInMiniApp() {
    return appType === 'MINI_APP';
}
/**
 * 对象转查询字符串
 * @return {object}
 * */
function objectToQueryString(obj) {
    return Object.keys(obj)
        .map(function (key) {
        return ''.concat(encodeURIComponent(key), '=').concat(encodeURIComponent(obj[key]));
    })
        .join('&');
}
/**
 * 是否支持半屏打开
 * @return {boolean}
 */
function isSupportFloat() {
    if (platform === 'android') {
        // 安卓大于5.1.39版本都支持半屏打开
        return sdkLib_1.compareVersion(version || '', '5.1.39');
    }
    else {
        // ios下
        if (isInMiniApp()) {
            // 小程序内不支持半屏打开
            return sdkLib_1.compareVersion(version || '', '6.0.5');
        }
        // h5下
        return sdkLib_1.compareVersion(version || '', '5.1.40');
    }
}
function isSupportOpenComponent() {
    return sdkLib_1.compareVersion(version || '', '6.3.35');
}
/**
 * 是否支持webview间消息传递
 * @return {boolean|*}
 */
function isSupportSendMsg() {
    if (isInMiniApp()) {
        // 小程序情况下，iOS下会存在canIUse判断能用，其实却不能用的情况
        if (platform === 'android') {
            return dd.canIUse('navigateToMiniProgram') && dd.canIUse('navigateBackMiniProgram');
        }
        if (platform === 'ios') {
            return sdkLib_1.compareVersion(version || '', '6.0.5');
        }
        return false;
    }
    else {
        // h5情况下
        return platform === 'android'
            ? sdkLib_1.compareVersion(version || '', '5.1.39')
            : sdkLib_1.compareVersion(version || '', '5.1.40');
    }
}
function navigateToMiniProgram(opt) {
    if (isInMiniApp()) {
        if (platform === 'android') {
            opt.ddAppParams.mainTask = true;
        }
        return dd.navigateToMiniProgram(opt);
    }
    var buildId = opt.ddAppParams ? opt.ddAppParams.buildId : '';
    if (opt && opt.ddAppParams) {
        delete opt.ddAppParams.deployVersion;
        delete opt.ddAppParams.buildId;
    }
    // H5打开小程序情况下存在双端不一致问题，ios走的是opt.path参数走extraData; android走的是ddAppParams的page参数（page/index?xxx）, 有path时拿不到extraData的数据，也拿不到page的数据。
    // TODO 需要发版解决不一致问题 @零封 @序元
    if (platform === 'android') {
        delete opt.path;
    }
    return navigateToMiniProgram_1.default(__assign(__assign({}, opt), { buildId: buildId }));
}
/**
 * 添加isSendMsg到url上
 * @param url
 * @return {string}
 */
function addIsSendMsgParam2Url(url) {
    if (url.indexOf('&') === -1) {
        return url + "?isSendMsg=true";
    }
    return url + "&isSendMsg=true";
}
/**
 * 打开钉钉统一授权小程序
 * @category biz Helpers
 * @param {INavigateToMiniProgramParams} opt - 唤起授权小程序入参
 * @support mob web
 * @example
 * // 小程序唤起授权小程序，半屏高度为375px
 * openAuthMiniApp({
 *  path: 'pages/home/home',
 *  panelHeight: '375'
 * })
 *
 * // 小程序唤起授权小程序，半屏高度为百分之75，并传递业务参数extraData
 * openAuthMiniApp({
 *  panelHeight: 'percent75',
 *  path: 'pages/home/home',
 *  extraData:{
 *    id:'xxx',
 *    name:'ssssss',
 *    invokePage: '/pages/index/index'
 *  }
 * })
 *
 * // H5 唤起授权小程序，半屏高度为百分之75，并传递业务参数extraData
 * openAuthMiniApp({
 *  panelHeight: 'percent75',
 *  path: 'pages/home/home',
 *  extraData:{
 *    id:'xxx',
 *    name:'ssssss'
 *  }
 * }).then((res)=>{
 *  // 处理返回数据
 * })
 *
 * @return {Promise<any>}
 */
function openAuthMiniApp(opt) {
    return new Promise(function (resolve, reject) {
        var path = opt.path, _a = opt.panelHeight, panelHeight = _a === void 0 ? 'percent67' : _a, _b = opt.float, float = _b === void 0 ? true : _b, _c = opt.extraData, extraData = _c === void 0 ? {} : _c;
        if (!(extraData === null || extraData === void 0 ? void 0 : extraData.from)) {
            extraData.from = extraData.corpId;
        }
        if (!path) {
            throw 'path is required，auth is pages/home/home , cancel auth is pages/cancel/index;';
        }
        var newPath = path + "?" + objectToQueryString(opt.extraData) + "&isFromCallComponent=true";
        if (isSupportOpenComponent() && !isInMiniApp()) {
            openAppByCallComponentOpenLink(AUTH_MINI_APPID, newPath, panelHeight).then(function (data) {
                resolve(data);
            });
            return;
        }
        var isSendMsg = isSupportSendMsg();
        var isFloat = isSupportFloat();
        var appId = opt.appId || AUTH_MINI_APPID;
        isFloatMiniAppOpen = true;
        if (isSendMsg) {
            // 支持传递数据，用navigateToMiniProgram打开新页面
            var ddAppParams = {
                // 安卓情况下，页面路径需要通过page参数传入
                page: newPath,
                panelHeight: panelHeight,
                deployVersion: opt.deployVersion,
                buildId: opt.buildId,
            };
            if (float && isFloat) {
                ddAppParams.ddMode = 'float';
            }
            navigateToMiniProgram(__assign(__assign({}, opt), { appId: appId, path: opt.path, ddAppParams: ddAppParams })).catch(function () {
                // 不能用navigateToMiniProgram打开时的补救措施
                openAppByOpenLink(appId, newPath, panelHeight).catch(function (err) {
                    isFloatMiniAppOpen = false;
                    reject({
                        err: err,
                        message: 'openLink failed',
                    });
                });
            });
        }
        else {
            openAppByOpenLink(appId, newPath, panelHeight).catch(function (err) {
                isFloatMiniAppOpen = false;
                reject({
                    err: err,
                    message: 'openLink failed',
                });
            });
        }
        if (!isInMiniApp()) {
            // h5接收数据
            registerResumeHandler(resolve);
        }
    });
}
exports.openAuthMiniApp = openAuthMiniApp;
function openAppByCallComponentOpenLink(miniAppId, path, panelHeight) {
    return callComponent_1.default({
        componentType: 'miniProgram',
        params: {
            miniAppId: miniAppId,
            page: path,
            target: 'float',
            panelHeight: panelHeight,
        },
        // @ts-ignore
        IMiniProgramParams: {
            miniAppId: miniAppId,
            page: path,
            target: 'float',
            panelHeight: panelHeight,
        },
    }).then(function (res) {
        console.log('callComponent res', res);
        if (res && res.detail) {
            return res.detail.extraData;
        }
        else {
            return null;
        }
    }).catch(function (err) {
        console.log('callComponent err', err);
        return null;
    });
    ;
}
function openAppByOpenLink(miniAppId, path, panelHeight) {
    if (isSupportSendMsg()) {
        path = addIsSendMsgParam2Url(path);
    }
    // 不支持传递数据，用openLink打开新页面
    var url = "dingtalk://dingtalkclient/action/open_mini_app?miniAppId=" + miniAppId + "&page=" + encodeURIComponent(path);
    if (isSupportFloat()) {
        url += "&ddMode=float&panelHeight=" + panelHeight;
    }
    return openLink_1.default({
        url: url,
        enableShare: false,
    });
}
var resumeHandler = null;
/**
 * H5情况下注册接收消息的事件
 */
function registerResumeHandler(resolve) {
    // 清除之前遗留的事件
    document.removeEventListener('resume', resumeHandler);
    resumeHandler = function (res) {
        if (!isFloatMiniAppOpen) {
            return;
        }
        isFloatMiniAppOpen = false;
        var data = getResponseData(res);
        resolve(data);
        document.removeEventListener('resume', resumeHandler);
    };
    document.addEventListener('resume', resumeHandler);
}
/**
 * 监听授权小程序返回结果的方法，在app.onLunch或app.onShow里调用。
 * @params res {object} onLunch或 onShow的入参
 * @params callback {function} 回调方法，可对返回数据二次处理，callback必须有return值（处理后给到page.onShow的数据）
 * @support mob
 * @example
 * // app.ts 的onLaunch里调用
 * onLaunch(options) {
 *   console.log('App Launch', options);
 *  onAuthAppBack(options, (data) => {
 *     // 这里可以对返回数据做二次处理，之后需要把数据返回到page.onShow
 *     dd.alert({
 *       title: 'app is onAppShow have data ：' + JSON.stringify(data),
 *     });
 *     return data;
 *   });
 * }
 * */
function onAuthAppBack(res, callback) {
    if (callback === void 0) { callback = function (r) {
        return r;
    }; }
    if (!isFloatMiniAppOpen) {
        return;
    }
    var data = getResponseData(res);
    data = callback ? callback(data) : data;
    emitter && emitter.emit(AUTH_BACK_DATA, data);
    isFloatMiniAppOpen = false;
}
exports.onAuthAppBack = onAuthAppBack;
/**
 * 处理授权数据，在调用小程序页面的onShow中使用
 * @params fn {function} 回调函数，入参为onAuthAppBack的callback处理后的数据
 * @example
 * // page.onShow 方法里调用
 * onShow(e) {
      disposeAuthData((options)=>{
        // 拿到授权小程序返回数据进行后面的逻辑处理
        dd.alert({
          title:'disposeAuthData',
          content:JSON.stringify(options)
        })
      })
    }
 * */
function disposeAuthData(fn) {
    if (emitter && !emitter.hasListeners(AUTH_BACK_DATA)) {
        emitter.on(AUTH_BACK_DATA, function (options) {
            fn(options);
        });
    }
}
exports.disposeAuthData = disposeAuthData;
/**
 * 关闭事件监听，同一个小程序多个页面调用disposeAuthData时，会出现多次监听，且页面关闭时监听不会关闭，因此需要在onHide里手动关闭
 * @example
 * // page.onHide 方法里调用
 * onHide(e) {
      offAuthListener();
    }
 * */
function offAuthListener() {
    if (emitter && emitter.hasListeners(AUTH_BACK_DATA) && !isFloatMiniAppOpen) {
        var listeners = emitter.listeners(AUTH_BACK_DATA);
        emitter.off(AUTH_BACK_DATA, listeners[listeners.length - 1]);
        emitter.removeListener(AUTH_BACK_DATA, listeners[listeners.length - 1]);
    }
}
exports.offAuthListener = offAuthListener;
function getResponseData(res) {
    if (isInMiniApp()) {
        return res && res.referrerInfo && res.referrerInfo.extraData;
    }
    var data = {};
    // H5情况下
    if (platform === 'android') {
        // 安卓 H5情况下
        var referrerInfo_1 = res && res.detail && res.detail.referrerInfo;
        try {
            data = JSON.parse(referrerInfo_1);
        }
        catch (e) { }
        return data.extraData;
    }
    // iOS H5情况下
    var referrerInfo = res && res.detail && res.detail.data && res.detail.data.referrerInfo;
    try {
        data = JSON.parse(referrerInfo);
    }
    catch (e) { }
    return data.extraData;
}



//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-design-libs@0.1.0@dingtalk-design-libs/biz/openAuthMiniApp/index.js
// module id = 898
// module chunks = 106